var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7 11.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
    stroke: "#3C3F47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5l3.143 3.143",
    stroke: "#3C3F47",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDExLjVDOS40ODUyOCAxMS41IDExLjUgOS40ODUyOCAxMS41IDdDMTEuNSA0LjUxNDcyIDkuNDg1MjggMi41IDcgMi41QzQuNTE0NzIgMi41IDIuNSA0LjUxNDcyIDIuNSA3QzIuNSA5LjQ4NTI4IDQuNTE0NzIgMTEuNSA3IDExLjVaIiBzdHJva2U9IiMzQzNGNDciLz4KPHBhdGggZD0iTTEwLjUgMTAuNUwxMy42NDMzIDEzLjY0MzMiIHN0cm9rZT0iIzNDM0Y0NyIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgNewSearch as ReactComponent };